import classnames from 'classnames';
import React from 'react';
import { DataFileEntity } from 'v2/DataFiles/models';
import angleIcon from 'v2/icons/angle.svg';
import downloadIconWhite from 'v2/icons/download-cloud-white.svg';
import paperList from 'v2/icons/paperList.svg';
import { formatDataFileType, formatDateLong } from 'v2/utils/textFormat';
import styles from './dataFileDetails.module.scss';

interface DataFileDetailsProps {
  data: DataFileEntity | null;
  onDeselect: () => void;
  onDownloadFile: (id: number) => void;
}

const DataFileDetails = ({
  data,
  onDeselect,
  onDownloadFile,
}: DataFileDetailsProps) => {
  return (
    <>
      {data ? (
        <div className={classnames(styles.withDataContainer)}>
          <button
            className={classnames('btn-link-primary', styles.deselectBtn)}
            onClick={onDeselect}
          >
            <img src={angleIcon} alt="downloadFile"></img>
            Deselect
          </button>
          <h2 className={styles.title}>File Details</h2>
          <div className={classnames(styles.fileInfoContainer)}>
            <img
              src={paperList}
              alt="fileIcon"
              className={styles.fileIcon}
            ></img>
            <div className={styles.fileDetailHeader}>
              <h2 className={classnames(styles.title)}>{data.name}</h2>
              <p className={styles.fileType}>
                {formatDataFileType(data.file_type)}
              </p>
              <p className={styles.date}>{formatDateLong(data.updated_at)}</p>
            </div>
          </div>
          <div className={styles.bottomContainer}>
            <h2
              className={classnames(
                'mb-3',
                styles.title,
                styles.descriptionTitle
              )}
            >
              Description
            </h2>
            <p className={styles.description}>{data.description}</p>
            <button
              className={classnames('btn btn-primary', styles.downloadFileBtn)}
              onClick={() => onDownloadFile(data.id)}
            >
              <img src={downloadIconWhite} alt="downloadFile"></img>
              Download File
            </button>
          </div>
        </div>
      ) : (
        <div className="h-100">
          <h2 className={styles.title}>File Details</h2>
          <div className={styles.noContentContainer}>
            <img
              src={paperList}
              alt="fileIcon"
              className={styles.fileIcon}
            ></img>
            <h3>No File Selected</h3>
            <p>Select a file to see its details</p>
          </div>
        </div>
      )}
    </>
  );
};

export default DataFileDetails;
